export specialInfoReducer = (state = {}, action) ->
  state
